<div class="outgoing-referral-card" (click)="onCardClick()">
  <!-- Header Row: Patient Name + Age + Status -->
  <div class="card-header">
    <div class="patient-row">
      <span class="patient-name">{{ patientNumber() | patientNumberPad }} | {{ patientName() }}</span>
      @if (patientAge(); as age) {
        <span class="patient-age">· {{ age }}</span>
      }
      @if (hasAllergies()) {
        <mat-icon class="allergy-indicator" matTooltip="Patient has allergies">warning</mat-icon>
      }
    </div>
    <mat-chip [ngClass]="statusClass()" class="status-chip" highlighted>
      {{ statusLabel() }}
    </mat-chip>
  </div>

  <!-- Sent To Row -->
  <div class="sent-to-row">
    <mat-icon class="arrow-icon">arrow_forward</mat-icon>
    <span class="doctor-name">{{ targetDoctorName() }}</span>
    @if (targetDoctorAvatarUrl()) {
      <img [src]="targetDoctorAvatarUrl()" class="doctor-avatar" alt="Doctor Avatar">
    }
  </div>

  <!-- Date Row -->
  <div class="date-row">
    <mat-icon class="date-icon">schedule</mat-icon>
    <span class="date-label">Sent</span>
    <span class="date-text">{{ formatDate(referral().createdDate) }}</span>
  </div>

  <!-- Medical Aid Row -->
  @if (medicalAidInfo(); as medicalAid) {
    <div class="medical-aid-row">
      <mat-icon class="medical-icon">local_hospital</mat-icon>
      <span class="medical-aid-text">{{ medicalAid }}</span>
    </div>
  }
</div>
